import { FC } from 'react';
import { Props } from './types';
import Modal from './../Modal';
import { NOTIFICATION_MODAL_ID } from './constants';

const NotificationModal: FC<Props> = () => {
  return (
    <Modal
      id={NOTIFICATION_MODAL_ID}
      renderChildren={() => <></>}
      notification={true}
    />
  );
};

export default NotificationModal;
